import { useEffect } from "react";
import { AppRouter } from "./router/AppRouter";

function CookiebotLoader() {
  useEffect(() => {
    const cbid = import.meta.env.VITE_COOKIEBOT_CBID?.trim();
    if (!cbid || document.getElementById("Cookiebot")) {
      return;
    }

    const script = document.createElement("script");
    script.id = "Cookiebot";
    script.src = "https://consent.cookiebot.com/uc.js";
    script.type = "text/javascript";
    script.async = true;
    script.setAttribute("data-cbid", cbid);
    script.setAttribute("data-blockingmode", "auto");

    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return null;
}

export default function App() {
  return (
    <>
      <CookiebotLoader />
      <AppRouter />
    </>
  );
}
